import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import OpzioniForm from "./OpzioniForm";
import { sbloccaOpzioni } from "./opzioniService";

const getErrorMessage = (error) => {
  const serverMessage = error?.response?.data?.message || error?.response?.data?.Message;
  if (serverMessage) return serverMessage;
  switch (error?.response?.status) {
    case 401: return "Password non corretta.";
    case 429: return "Troppi tentativi. Riprova più tardi.";
    case 503: return "La password di accesso non è stata configurata sul server.";
    default: return "Impossibile verificare la password.";
  }
};

const OpzioniAccessModal = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [expiresAtUtc, setExpiresAtUtc] = useState("");
  const [isUnlocking, setIsUnlocking] = useState(false);
  const [error, setError] = useState("");

  const resetAndClose = () => {
    setPassword(""); setShowPassword(false); setAccessToken("");
    setExpiresAtUtc(""); setError(""); setIsUnlocking(false); onClose();
  };

  useEffect(() => {
    if (!show) {
      setPassword(""); setAccessToken(""); setExpiresAtUtc(""); setError("");
    }
  }, [show]);

  const handleUnlock = async (event) => {
    event.preventDefault();
    if (!password || isUnlocking) return;
    setIsUnlocking(true);
    setError("");
    try {
      const response = await dispatch(sbloccaOpzioni(password));
      const token = response?.accessToken || response?.AccessToken || "";
      if (!token) throw new Error("Token di accesso non ricevuto.");
      setAccessToken(token);
      setExpiresAtUtc(response?.expiresAtUtc || response?.ExpiresAtUtc || "");
      setPassword("");
    } catch (unlockError) {
      setError(getErrorMessage(unlockError));
    } finally {
      setIsUnlocking(false);
    }
  };

  return (
    <Modal show={show} onHide={resetAndClose} size="xl" centered scrollable backdrop="static">
      <Modal.Header className="bg-primary text-white">
        <Modal.Title className="text-white">{accessToken ? "Opzioni struttura" : "Accesso alle opzioni avanzate"}</Modal.Title>
        <i className="i-Close-Window cursor-pointer text-18" role="button" aria-label="Chiudi" onClick={resetAndClose} />
      </Modal.Header>
      <Modal.Body>
        {!accessToken ? (
          <form onSubmit={handleUnlock}>
            <p>Inserisci la password riservata ai super amministratori per visualizzare le opzioni.</p>
            {error && <div className="alert alert-danger">{error}</div>}
            <label htmlFor="opzioni-access-password"><b>Password</b></label>
            <div className="input-group">
              <input
                id="opzioni-access-password"
                type={showPassword ? "text" : "password"}
                className="form-control"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                autoFocus
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword((current) => !current)}
                aria-label={showPassword ? "Nascondi password" : "Mostra password"}
              >
                <i className={showPassword ? "i-Lock-2" : "i-Eye"} />
              </button>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button type="button" variant="outline-secondary" onClick={resetAndClose} disabled={isUnlocking}>Annulla</Button>
              <Button type="submit" variant="primary" disabled={!password || isUnlocking}>
                {isUnlocking ? "Verifica..." : "Accedi"}
              </Button>
            </div>
          </form>
        ) : (
          <>
            {expiresAtUtc && (
              <div className="alert alert-info py-2">
                Accesso temporaneo autorizzato. La sessione scade alle {new Date(expiresAtUtc).toLocaleTimeString("it-IT")}.
              </div>
            )}
            <OpzioniForm accessToken={accessToken} onCancel={resetAndClose} onSaved={resetAndClose} />
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default OpzioniAccessModal;
